import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { convertImageUrlToBase64, getDocumentDefinitionContext } from '../getDoumentDefinitionContent';

import prospectHeaderBar from '../../../assets/letterheads/prospect_header_bar.png';
import prospectFooterBar from '../../../assets/letterheads/prospect_footer_bar.png';
import prospectLogoImgUrl from '../../../assets/letterheads/prospect_logo.png';
import { AddressInfo } from '../../../shared/models/AddressInfo';


// Function to generate the document definition
export const getDocumentDefinitionProspectLetterHead = async (empDetails: any, recipientInfo: AddressInfo, checked: boolean, verify: string): Promise<TDocumentDefinitions> => {
    const base64Image = await convertImageUrlToBase64(prospectLogoImgUrl);
    const base64ImageHeader = await convertImageUrlToBase64(prospectHeaderBar);
    const base64ImageFooter = await convertImageUrlToBase64(prospectFooterBar);
    
    
    return {
        // Page size and margins
        pageSize: 'A4',
        //pageMargins: [60, 35, 60, 88], // Left, top, right, bottom margins
        pageMargins: [60, 35, 60, 80],
        //Dynamic header
        header: (currentPage, pageCount, pageSize) => {
           const headerContent = [];
           if (base64ImageHeader) {
            const imageObject = {
                image: base64ImageHeader, // Ensure this is a correct base64 encoded string
                width: pageSize.width,
                alignment: 'center', // You may need to specify an alignment for the image
            };
            headerContent.push(imageObject)
            }
            
           return [headerContent];
            
        },

        // Dynamic footer
        footer: (currentPage, pageCount, pageSize) => {
            // Create the array for content with proper typings
            const footerContent = [];
            // Define the text object with the correct properties
            // const textObject = {          
            // };
            // footerContent.push(textObject);
            // Define the image object if base64ImageFooter is provided
            if (base64ImageFooter) {
                const imageObject = {
                    image: base64ImageFooter, // Ensure this is a correct base64 encoded string
                    width: pageSize.width+100,
                    alignment: 'center', // You may need to specify an alignment for the image
                };
                footerContent.push(imageObject);
            }

            return [footerContent];
        },

        // Content structure
        content: [
            //logo
            {
                // image: base64Image, // Ensure this is a correct base64 encoded string
                // width: 150,
                // alignment: 'left',
                // margin: [0, 20, 0, 20], // Adjust margins to position correctly

                margin: [0, 20, 0, 5],
                columns: [
                    {
                        image: base64Image,
                        width: 200,
                        alignment: 'left',
                    },
                    {
                        alignment: 'right',
                        margin: [0, 0, 0, 0],
                        stack: [
                            { text: '950 E Paces Ferry,', bold: true, fontSize: 10 },
                            { text: 'Suite 2000, Atlanta, GA', fontSize: 10 },
                            { text: 'Phone: (847) 299 3636', fontSize: 10 },
                            { text: 'Fax: (847) 789 8489', fontSize: 10 },
                            { text: 'www.prospectair.com', fontSize: 10, color: '#555' }
                        ]
                    }
                ]
            },
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 100,
                        y1: 0,
                        x2: 400, // total width minus margins (60 + 60)
                        y2: 0,
                        lineWidth: 1,
                        lineColor: '#b1c9eb' // soft blue like in the screenshot
                    }
                ],
                margin: [60, 0, 60, 20] // aligns with content margin
            },
            // Main content
            ...getDocumentDefinitionContext(empDetails, recipientInfo, verify, checked)
        ],
        defaultStyle: {
            font: 'Roboto' // Set Calibri as the default font
        },
        // Styles used in the document
        styles: {
            contentStyle: {
                fontSize: 12
            }
        },
    };
};

